const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Slide down Warranty Registration & Claims
 */
const ClaimsSlide = {

    init() { 

        $('.warranty-btn').on('click', function() {

            var dataLink = '#' + $(this).attr("data-link");

            if($(this).hasClass('warranty-open')) {

                $(this).removeClass('warranty-open');
                $(dataLink).slideUp().animate({opacity:0}, {queue: false});

            } else {

                if($('.warranty-btn').hasClass('warranty-open')) {
                    var current = '#' + $('.warranty-open').attr("data-link");
                    $(current).slideUp().animate({opacity:0}, {queue: false});
                }
                
                $('.warranty-btn.warranty-open').removeClass('warranty-open');
                $(this).addClass('warranty-open');
                $(dataLink).slideDown().animate({opacity:1}, {queue: false});
                
            }
        return false;
        });
    }

    

};

export default ClaimsSlide;